import { EventType } from "@/types";

import { axios } from "../axios.instance";

export type WithdrawEventRequest = {
  eventId: EventType["id"];
};

export type WithdrawEventResponse = unknown;

export const withdrawEvent = async (body: WithdrawEventRequest): Promise<WithdrawEventResponse> => {
  const { data } = await axios.post(`/events/${body.eventId}/withdraw`);

  return data;
};
